import studentRequest from 'utils/studentRequest'


export const singlePdf = async(response,studentName,studentId)=>{
    // const res = await studentRequest.get(`/students/${studentId}`)
    // const cvUrlTYPE = res?.data?.data?.cvUrl?.type || 'pdf'
//     const blob = new Blob([response], { type: 'application/pdf' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `${studentName} resume.pdf`;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//    return window.URL.revokeObjectURL(url);

    const disposition = response.headers?.['content-disposition'] || '';
  console.log('disposition:', disposition);
  
  // Extract filename
  const match = disposition.match(/filename="?(.+?)"?$/);
  const originalFilename = match ? match[1] : 'resume.pdf';
  console.log('originalFilename:', originalFilename);
  
  // Get extension from filename
  const ext = originalFilename.split('.').pop().toLowerCase();
  console.log('ext:', ext);
  
  const mimeTypes = {
    'pdf': 'application/pdf',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  };

  const mimeType = mimeTypes[ext] || 'application/octet-stream';
  
  const blob = new Blob([response.data], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  
  const a = document.createElement('a');
  a.href = url;
  a.download = `${studentName} resume.${ext}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  
  return window.URL.revokeObjectURL(url);
}

export const zipFile = async(response) =>{
    const blob = new Blob([response], { type: 'application/zip' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Download_Resumes.zip';
    document.body.appendChild(a);
    a.click();
    a.remove();
   return window.URL.revokeObjectURL(url);
}